module.exports = __webpack_public_path__ + "static/07-072e07762726c6603e1aa62e837ea2a8.png";